export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-screen flex flex-col">
      <div className="absolute inset-0 bg-[#080808]">
        <img
          alt="background"
          className="w-full h-full object-cover object-center opacity-30"
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20technology%20background%20with%20glowing%20green%20neon%20grid%20lines%2C%20financial%20data%20visualization%2C%20minimal%20futuristic%20aesthetic%2C%20dark%20black%20background%20with%20subtle%20emerald%20light%20patterns%2C%20high%20contrast%2C%20digital%20art&width=1920&height=1080&seq=hero-bg-01&orientation=landscape"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/90"></div>
      </div>

      <div className="relative z-10 flex-1 flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-24 sm:py-28 lg:py-32 w-full grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="flex flex-col gap-5 sm:gap-6">
            <div className="inline-flex items-start sm:items-center gap-2">
              <span className="inline-block bg-[#FF6B35]/15 border border-[#FF6B35]/40 text-[#FF6B35] text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full leading-snug">
                ⚠️ Atención Estrategas: Deja de perder dinero por el desorden.
              </span>
            </div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black leading-[1.08] text-white">
              EL <span className="text-[#00FF88]">SUPER PACK</span> DEFINITIVO PARA{' '}
              <span className="text-[#00FF88]">GESTIONAR TUS FINANZAS</span> Y ESCALAR SIN FRICCIÓN.
            </h1>
            <p className="text-gray-400 text-base sm:text-lg leading-relaxed max-w-xl">
              Dos programas top: <strong className="text-white">Stock Simple + Budgettrack</strong>. Tu inventario y tus números controlados desde tu mano por menos de lo que cuesta una cena.
            </p>
            <div id="hero-cta" className="flex flex-col sm:flex-row gap-4 mt-2">
              <a
                href="https://pay.hotmart.com/H105250353B?checkoutMode=10"
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center justify-center gap-3 bg-gradient-to-r from-[#FF6B35] to-[#FF3D00] text-white font-black text-base md:text-lg px-8 py-5 rounded-2xl hover:scale-105 transition-all duration-300 cursor-pointer text-center shadow-lg shadow-orange-900/40 w-full sm:w-auto whitespace-nowrap"
              >
                <span className="text-xl flex-shrink-0">👉</span>
                <span className="leading-snug">
                  SÍ, QUIERO EL CONTROL TOTAL<br className="block" />
                  POR $12 AL AÑO
                </span>
              </a>
            </div>
            <div className="flex items-center gap-6 mt-2 flex-wrap">
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-shield-check-line text-[#00FF88] text-base"></i>
                </div>
                <span className="text-gray-400 text-xs font-medium">100% Seguro</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-cloud-line text-[#00FF88] text-base"></i>
                </div>
                <span className="text-gray-400 text-xs font-medium">En la Nube</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-smartphone-line text-[#00FF88] text-base"></i>
                </div>
                <span className="text-gray-400 text-xs font-medium">Cualquier Dispositivo</span>
              </div>
            </div>
          </div>
          <div className="hidden lg:flex items-center justify-center">
            <div className="relative w-full max-w-lg">
              <div className="absolute -inset-4 bg-[#00FF88]/10 rounded-3xl blur-2xl"></div>
              <img
                alt="Dashboard de Stock Simple y Budgettrack"
                className="relative rounded-2xl w-full h-auto object-cover"
                src="https://readdy.ai/api/search-image?query=professional%20financial%20dashboard%20on%20laptop%20and%20smartphone%20screens%20floating%2C%20dark%20background%2C%20green%20neon%20data%20charts%20and%20graphs%2C%20inventory%20management%20interface%20with%20clean%20minimal%20UI%20design%2C%20high%20tech%20product%20mockup%2C%20glowing%20emerald%20accents%2C%20dark%20moody%20atmosphere&width=600&height=500&seq=hero-mockup-02&orientation=landscape"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="relative z-10 pb-10 flex justify-center">
        <div className="flex flex-col items-center gap-2 animate-bounce">
          <span className="text-gray-500 text-xs tracking-widest uppercase">Descubre más</span>
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-down-line text-[#00FF88]"></i>
          </div>
        </div>
      </div>
    </section>
  );
}
